<template>
  <header class="navigation-header">
    <nuxt-link to="/" aria-label="VORTEC — go to homepage"><span v-html="icons.vortecLogo"></span></nuxt-link>

    <div class="header-box">
      <nuxt-link
        aria-label="Navigate to contact section"
        to="/#contact"
        class="navigation-link text-center cta-navigation-link text-animation text-animation-button">
        <p class="text-animation-visible">Let's talk</p>
        <p class="text-animation-hidden">Let's talk</p>
      </nuxt-link>
      <button
        type="button"
        class="hamburger-menu"
        :class="{ 'menu-opened': menuOpened }"
        :aria-expanded="menuOpened"
        aria-controls="primary-navigation"
        :aria-label="menuOpened ? 'Close menu' : 'Open menu'"
        @click="menuOpened = !menuOpened">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </button>
    </div>
  </header>
  <nav
    id="primary-navigation"
    aria-label="Main"
    class="navigation-menu"
    :class="{ 'mobile-menu-opened': menuOpened, scrolled }">
    <nuxt-link
      @click="menuOpened = false"
      to="/#home"
      class="navigation-link text-center text-animation"
      aria-label="Navigate to home section">
      <p class="text-animation-visible body-text-medium">Home</p>
      <p class="text-animation-hidden body-text-medium">Home</p>
    </nuxt-link>
    <nuxt-link
      @click="menuOpened = false"
      to="/services"
      class="navigation-link text-center text-animation"
      aria-label="Navigate to services page">
      <p class="text-animation-visible body-text-medium">Services</p>
      <p class="text-animation-hidden body-text-medium">Services</p>
    </nuxt-link>
    <nuxt-link
      @click="menuOpened = false"
      to="/projects"
      class="navigation-link text-center text-animation"
      aria-label="Navigate to projects page">
      <p class="text-animation-visible body-text-medium">Projects</p>
      <p class="text-animation-hidden body-text-medium">Projects</p>
    </nuxt-link>
    <nuxt-link
      @click="menuOpened = false"
      to="/faq"
      class="navigation-link text-center text-animation"
      aria-label="Navigate to FAQ page">
      <p class="text-animation-visible body-text-medium">FAQ</p>
      <p class="text-animation-hidden body-text-medium">FAQ</p>
    </nuxt-link>
    <nuxt-link
      @click="menuOpened = false"
      to="/#contact"
      class="navigation-link text-center cta-navigation-link text-animation text-animation-button"
      aria-label="Navigate to contact section">
      <p class="text-animation-visible">Let's talk</p>
      <p class="text-animation-hidden">Let's talk</p>
    </nuxt-link>
  </nav>
</template>

<script lang="ts" setup>
import icons from '~/icons';

const menuOpened = ref(false);
const scrolled = ref(false);

// Close the mobile menu whenever the route changes (covers hash links like
// "/#contact" that don't unmount this component) and let Escape dismiss it.
const route = useRoute();
watch(
  () => route.fullPath,
  () => {
    menuOpened.value = false;
  }
);

// rAF-throttled, passive scroll handler. We flip a reactive flag instead of
// poking the DOM with querySelector on every scroll event, and we tear the
// listener down on unmount so it doesn't leak or stack across navigations.
let ticking = false;
const onScroll = () => {
  if (ticking) return;
  ticking = true;
  requestAnimationFrame(() => {
    scrolled.value = window.scrollY > 60;
    ticking = false;
  });
};

const onKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    menuOpened.value = false;
  }
};

onMounted(() => {
  scrolled.value = window.scrollY > 60;
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('keydown', onKeydown);
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll);
  window.removeEventListener('keydown', onKeydown);
});
</script>
